<template>
  <div v-if="sponsoring">
    <div class="entete">
      <div class="columns mgb-0">
        <div class="column pdb-0">
          <h1 class="title is-size-3">
            {{ getTitle }}
            <b-tag v-if="getEtatProduit"
                   type="has-background-subMenu" class="has-text-white mgl-5px">
              {{$t('catalogue.etatProduit')}}
            </b-tag>
          </h1>
        </div>
        <div class="column is-narrow pdb-0">
          <div class="is-pulled-right buttons boutonAction">
            <button @click="$router.go(-1)"
                    class="button btn-modal-annuler is-cancel">
              {{ $t('general.button.cancel') }}
            </button>

            <div class="button is-addOrEdit" @click="saveProduct()">
              <span>
                {{ $t('general.button.sauvegarder') }}
              </span>
            </div>
            <piece-jointe-button
              class="mgr-2"
              :perm="permCatalogue.maj">
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <breadcrumb :breadcrumb="breadcrumb"/>
      <error-msg-component :messages="messages"
                           :error="error"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :title="'editionClient.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
      <div class="tab">
        <ul>
          <li
            v-for="(tab, index) in tabs"
            :key="index"
            :class="{'is-active': activeTab === tab.component}"
            @click="activeTab = tab.component">
            {{ $t(tab.libelle) }}
          </li>
        </ul>
      </div>
    </div>
    <div class="corps">
      <component
        :is="activeComponent.component"
        :detail="activeComponent.detail"
        :showMsgRegroupementProduit="activeComponent.detail"
        :produit="sponsoring"
        :sousProduit="sponsoring.produitSponsoring"
        :breadcrumb="breadcrumb"
        :isDisabled="false"
        :commissions="sponsoring.commissionsVendeur"
        :permissions="permCatalogue"/>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/general/breadcrumb';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import inProgress from '@/services/general/inProgress';
import messageErreur from '@/services/general/messageErreur';
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import validationProduit from '@/services/catalogue/validation/validationProduit';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/catalogue/validation/champsProduitTranslator';
import { create as createProduitSponsoring, update as updateProduitSponsoring, get as getSponsoring } from '@/api/produit/produitSponsoring';
import messageSucces from '@/services/general/messageSucces';
import informationProduit from '@/components/catalogue/produitGeneralPresse/edition/m_produitInformation';
import { formatProduitAfterGet, formatProduitBeforeSave } from '@/services/catalogue/formatProduit';
import objectifVente from '@/components/catalogue/produitGeneralPresse/edition/objectifVente';
import regleCommission from '@/components/catalogue/produitGeneralPresse/edition/regleCommission';
import reglesAchat from '@/components/catalogue/produitGeneralPresse/edition/reglesAchat';
import genererProduitSponsoring from '@/services/presse/sponsoring/genererProduitSponsoring';
import cgv from '@/components/catalogue/produitGeneralPresse/edition/cgv';
import prestations from '@/components/catalogue/produitGeneralPresse/edition/prestations';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import demandeInterventionType from '@/components/catalogue/produitGeneral/demandeInterventionType/demandeInterventionType';

const Attachments = createNamespacedHelpers('attachments');
const Societe = createNamespacedHelpers('societe');
const ProduitStore = createNamespacedHelpers('produit');

export default {
  name: 'm_editionProduitSponsoring',
  data() {
    return {
      error: false,
      activeTab: 'informationProduit',
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      sponsoring: null,
      libelle: null,
      permCatalogue: CATALOGUE,
    };
  },
  components: {
    breadcrumb,
    errorMsgComponent,
    informationProduit,
    objectifVente,
    reglesAchat,
    regleCommission,
    cgv,
    prestations,
    pieceJointeButton,
    demandeInterventionType,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...ProduitStore.mapGetters({
      produit: 'produit',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('catalogue.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('catalogue.titleProduit'), route: { name: 'l.bodac.catalogue' }, isActive: false },
        { title: this.$i18n.t('catalogue.type.sponsoring'), route: { name: 'm.bodac.catalogue-typeCreation' }, isActive: false },
        { title: this.getTitle, route: { name: 'm.bodac.catalogue-nouveauSponsoring' }, isActive: true },
      ];
    },
    getTitle() {
      return this.$route.params.produitId ? this.$i18n.t('catalogue.editProduct.title',
        { libelle: this.libelle }) : this.$i18n.t('catalogue.newProduct.title');
    },
    getEtatProduit() {
      return (this.$route.params.produitId && !this.sponsoring.actif);
    },
    tabs() {
      return [
        {
          component: 'informationProduit',
          libelle: 'catalogue.newProduct.tab.product',
          show: true,
          detail: false,
        },
        {
          component: 'prestations',
          libelle: 'catalogue.newProduct.tab.prestations',
          show: true,
          detail: false,
        },
        {
          component: 'regleCommission',
          libelle: 'catalogue.newProduct.tab.regleCommission',
          show: true,
          detail: !!this.sponsoring.regroupementProduitId,
        },
        {
          component: 'objectifVente',
          libelle: 'catalogue.newProduct.tab.objectifVente',
          show: true,
          detail: !!this.sponsoring.regroupementProduitId,
        },
        {
          component: 'reglesAchat',
          libelle: 'catalogue.newProduct.tab.regleAchat',
          show: true,
          detail: !!this.sponsoring.regroupementProduitId,
        },
        {
          component: 'cgv',
          libelle: 'catalogue.newProduct.tab.cgv',
          show: true,
          detail: !!this.sponsoring.regroupementProduitId,
        },
        {
          component: 'demandeInterventionType',
          libelle: 'catalogue.newProduct.tab.demandeInterventionType',
          show: true,
          detail: false,
        },
      ].filter(t => t.show);
    },
    activeComponent() {
      return this.tabs.find(t => t.component === this.activeTab);
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    ...ProduitStore.mapActions({
      updateProduit: 'updateProduit',
    }),
    inProgress() {
      inProgress(this.$i18n);
    },
    async saveProduct() {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      const loadingComponent = this.$buefy.loading.open();
      let produitUpdated = null;
      const produit = formatProduitBeforeSave(this.sponsoring);
      try {
        if (this.$route.params.produitId) {
          produitUpdated = (await updateProduitSponsoring(produit)).data.result;
          await this.updateAttachments(this.$route.params.produitId);
          messageSucces(this.$t('catalogue.updateSuccess'));
        } else {
          produitUpdated = (await createProduitSponsoring(produit)).data.result;
          await this.setAttachmentElementId({ id: produitUpdated.id });
          await this.insertAttachments(produitUpdated.id);
          messageSucces(this.$t('catalogue.addSuccess'));
        }
        await this.$router.push(
          { name: 'c.bodac.catalogue-detailSponsoring', params: { id: produitUpdated.id } },
        );
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.error = true;
          this.messages = validationProduit(e.response);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },

  beforeRouteEnter(to, from, next) {
    let tab = '';
    switch (from.name) {
      default:
        tab = 'informationProduit';
    }
    next(vm => {
      vm.activeTab = tab;
    });
  },

  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Sponsoring' });
      if (this.produit) {
        this.sponsoring = this.produit;
        this.updateProduit(null);
      } else if (this.$route.params.produitId) {
        const sponsoring = (await getSponsoring(this.$route.params.produitId)).data.result;
        this.sponsoring = formatProduitAfterGet(sponsoring);
        await this.setAttachmentElementId({ id: this.$route.params.produitId });
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.sponsoring.libelle }));
      } else {
        this.setInformationPage(this.$t('pageGescom.produit.creationSponsoring'));
        this.sponsoring = await genererProduitSponsoring();
        this.sponsoring.societeId = this.societeActiveId;
      }
      this.libelle = cloneDeep(this.sponsoring.libelle);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
